import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Phone, PhoneCall, PhoneForwarded, Wifi, Check } from "lucide-react";

const PhonePage = () => {
  const providers = [
    { name: "NetGSM", type: "SIP Trunk", features: ["Sanal santral", "Numara taşıma", "Çağrı yönlendirme"] },
    { name: "Verimor", type: "SIP Trunk", features: ["Anlık aktivasyon", "Esnek dakika paketi", "Gelişmiş raporlama"] },
    { name: "Twilio", type: "Cloud API", features: ["Global numaralar", "Programatik yönetim", "WebRTC desteği"] },
    { name: "Vonage", type: "Cloud API", features: ["Uluslararası aramalar", "SIP ve API hibrit", "Kapsamlı analitik"] },
  ];

  const features = [
    { icon: PhoneCall, title: "Gelen Çağrı Yönetimi", desc: "Gelen tüm çağrılar sesli AI ajanınız tarafından karşılanır, doğal dilde menü navigasyonu ile doğru birime yönlendirilir." },
    { icon: PhoneForwarded, title: "Akıllı Aktarım", desc: "AI çözemediğinde çağrıyı transkript ve duygu skoru ile birlikte canlı temsilciye aktarır." },
    { icon: Wifi, title: "WebRTC Desteği", desc: "Tarayıcı tabanlı çağrı altyapısı ile ek donanım gerektirmeden doğrudan web'den arama yapın ve alın." },
  ];

  const hero = (
    <PageHero
      eyebrow="Ürün"
      title="Telefon Altyapısı"
      subtitle="NetGSM, Verimor, Twilio ve Vonage ile entegre çalışan telefon altyapımız sayesinde mevcut numaralarınızla hemen yayına başlayın."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/telephony.jpg" alt="Telefon altyapısı" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-5 mb-16">
              {features.map((f) => (
                <div key={f.title} className="p-6 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <f.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{f.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{f.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Desteklenen Sağlayıcılar</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
              {providers.map((p) => (
                <div key={p.name} className="p-5 rounded-2xl transition-colors duration-200" style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}>
                  <h3 className="text-[18px] font-bold mb-1" style={{ color: "var(--fg)" }}>{p.name}</h3>
                  <p className="text-[12px] mb-4 uppercase tracking-wider" style={{ color: "var(--muted)" }}>{p.type}</p>
                  <ul className="space-y-2">
                    {p.features.map((feat) => (
                      <li key={feat} className="flex items-center gap-2 text-[13px]" style={{ color: "var(--fg)", opacity: 0.8 }}>
                        <Check size={13} style={{ color: "#10b981", flexShrink: 0 }} />{feat}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>            <div className="mt-12 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/voip-network.jpg"
                alt="VoIP ağ altyapısı"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "320px" }}
                loading="lazy"
              />
            </div>          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6 text-center" style={{ background: "var(--section-surface-1)" }}>
          <h2 className="text-[24px] font-bold mb-4" style={{ color: "var(--fg)" }}>Mevcut numaranızla başlayın</h2>
          <p className="text-[15px] mb-8 max-w-xl mx-auto" style={{ color: "var(--fg)", opacity: 0.82 }}>
            Numara taşıma işlemini biz yönetiyoruz. Mevcut santralinizle de entegre çalışabiliriz.
          </p>
          <a href="https://app.verasist.ai" className="inline-block px-10 py-4 rounded-full font-bold text-[15px] transition-all duration-200" style={{ background: "var(--brand-navy)", color: "#fff" }}>
            <Phone size={18} className="inline mr-2" />Hemen Başlayın
          </a>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default PhonePage;
